/* React Higher Order Component which fetches organization integration tag changes from import operation for organization where id = props.orgId
    Child (WrappedComponent) will render whether orgTagImportChanges is defined or not
    - NOTE: this component will NOT & CANNOT fetch this data automatically from the server.
    - This type of data is only generated as the response to an Integration Tags CSV Import request
    child will receive props: {
        orgId:  PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        orgTagImportChanges: PropTypes.shape({
            tagsToAdd: PropTypes.array,
            tagsToDelete: PropTypes.array,
            tagsToUpdate: PropTypes.array,
            existingTagsHash: PropTypes.string.isRequired,
        })
    }

*/

import React from 'react';
import PropTypes from 'prop-types';

const OrganizationStore = require('../../stores/OrganizationStore');
const ReactUtil = require('../../util/ReactUtil');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

const defaultProps = {};

export default function withOrganizationTagImportChanges(WrappedComponent) {
    class WithOrganizationTagImportChanges extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                orgTagImportChanges: OrganizationStore.getStateOrganization(props.orgId).orgTagImportChanges,
                organizationStoreAction: OrganizationStore.getState().action,
            };

            this.unsubscribes = [OrganizationStore.listen(this.onOrganizationStoreChange.bind(this))];
        }

        UNSAFE_componentWillMount() {
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(unsubscribeCallback => unsubscribeCallback());
        }

        onOrganizationStoreChange(newState) {
            this.setState({
                orgTagImportChanges: OrganizationStore.getStateOrganization(this.props.orgId).orgTagImportChanges,
                organizationStoreAction: OrganizationStore.getState().action,
            });
        }

        render() {
            return (
                <WrappedComponent
                {...this.props}
                orgTagImportChanges={this.state.orgTagImportChanges}
                organizationStoreAction={this.state.organizationStoreAction}
                />
            );
        }
    }

    WithOrganizationTagImportChanges.propTypes = propTypes;
    WithOrganizationTagImportChanges.defaultProps = defaultProps;
    WithOrganizationTagImportChanges.displayName = `WithOrganizationTagImportChanges(${ReactUtil.getComponentDisplayName(WrappedComponent)})`;
    return WithOrganizationTagImportChanges;
}